import React from 'react';
import { Spin, Form, Button, message } from 'antd';
import { connect } from 'dva';
import FormCreate from '../../../../../components/FormCreate/index';
import Container from '../../../../../components/Container';
import BannerUpload from './components/BannerUpload';
import SelectArticle from './components/SelectArticle';
import SelectModel from './components/SelectModel';
import PlateSetting from './components/PlateSettting';
import PhonePreview from './components/PhonePreview';

import styles from './index.less';
import { GetQueryString, getAppCode } from '../../utils/utils';

const { Item } = Form;
const {
  FormTitle,

  FormRadioGroup,
} = FormCreate;

@Form.create()
@connect(({ homePage }) => ({
  ...homePage,
}))
class Homepage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    this.fetchTemplateList();
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch({
      type: 'homePage/reset',
    });
  }

  // 初始设置
  fetchTemplateList = () => {
    const { dispatch } = this.props;
    dispatch({
      type: 'homePage/fetchTemplateList',
      params: {
        appCode: getAppCode(),
      },
    }).then(res => {
      const { form } = this.props;
      const { setFieldsValue } = form;
      const { templateName, carouselModule } = res;
      const { moduleType, newsType } = carouselModule;
      setFieldsValue({ templateName, moduleType, newsType });
    });
  };

  resetModuleType = e => {
    const { value } = e.target;
    const { formData, dispatch, form } = this.props;
    const { setFieldsValue } = form;
    const { carouselModule } = formData;
    setFieldsValue({ newsType: 1 });
    dispatch({
      type: 'homePage/saveState',
      payload: {
        formData: {
          ...formData,
          carouselModule: {
            ...carouselModule,
            carousel: '',
            newsType: 1,
            moduleType: value,
          },
        },
      },
    });
  };

  resetNewsType = e => {
    const { value } = e.target;
    const { formData, dispatch, form } = this.props;
    const { setFieldsValue } = form;
    const { carouselModule } = formData;
    setFieldsValue({ newsType: 1 });
    dispatch({
      type: 'homePage/saveState',
      payload: {
        formData: {
          ...formData,
          carouselModule: {
            ...carouselModule,
            carousel: '',
            newsType: value,
          },
        },
      },
    });
  };

  resetTemplateName = e => {
    const { value } = e.target;
    const { formData, dispatch } = this.props;
    dispatch({
      type: 'homePage/saveState',
      payload: {
        formData: {
          ...formData,
          templateName: value,
        },
      },
    });
  };

  callbackImgUrl = carousel => {
    const { formData, dispatch } = this.props;
    const { carouselModule } = formData;
    dispatch({
      type: 'homePage/saveState',
      payload: {
        formData: {
          ...formData,
          carouselModule: {
            ...carouselModule,
            carousel: carousel.join(',') || '',
          },
        },
      },
    });
  };

  backgroundImgUrl = picurl => {
    const { formData, dispatch } = this.props;
    dispatch({
      type: 'homePage/saveState',
      payload: {
        formData: {
          ...formData,
          picurl: picurl.join(',') || '',
        },
      },
    });
  };

  preview = () => {
    const { formData, phoneData, customerSelectNews, dispatch } = this.props;
    const { carouselModule } = formData;
    const { carousel, moduleType } = carouselModule;

    let bannerData = [];
    if (moduleType === 2) {
      bannerData = carousel.split(',');
    } else {
      bannerData = customerSelectNews;
    }
    dispatch({
      type: 'homePage/saveState',
      payload: {
        formData: {
          ...formData,
        },
        phoneData: {
          ...phoneData,
          ...formData,
          bannerData,
        },
      },
    });
  };

  save = () => {
    const { formData } = this.props;
    const { templateName, carouselModule } = formData;
    const { carousel = '', newsType, moduleType } = carouselModule;
    if (!templateName) {
      message.error('请输入官网名称');
      return;
    }
    if (moduleType === 2 && !carousel) {
      message.error('请上传轮播内容');
      return;
    }
    if (moduleType === 3 && newsType === 2 && !carousel) {
      message.error('请选择轮播内容');
      return;
    }

    this.fetchSaveTemplate(formData);
  };

  fetchSaveTemplate = params => {
    const { dispatch } = this.props;
    dispatch({
      type: 'homePage/fetchSaveTemplate',
      params: { ...params, appCode: getAppCode() },
    }).then(() => {
      message.success('保存成功');
      this.fetchTemplateList();
    });
  };

  renderFooter = () => {
    const footerParams = {
      states: !0,
      demFooter: (
        <>
          <Button type="default" onClick={this.fetchTemplateList}>
            恢复已有设置
          </Button>
          <Button type="default" onClick={this.preview}>
            预览
          </Button>
          <Button type="primary" onClick={this.save}>
            保存
          </Button>
        </>
      ),
    };
    return footerParams;
  };

  renderModelImage = () => {
    const { form, formData } = this.props;
    const { getFieldDecorator } = form;
    const { stencilId, picurl = '' } = formData;
    if (stencilId === 31 || stencilId === 41 || stencilId === 42) {
      return (
        <Item label="背景图">
          {getFieldDecorator('bannerUpload', {
            rules: [{ required: false, message: '请上传背景图片' }],
          })(
            <BannerUpload
              fileList={(picurl && picurl.split(',')) || []}
              imageNumber={stencilId === 31 ? 2 : 1}
              tips={
                stencilId === 31
                  ? '说明：请上传2张，建议上传400*190像素的图片，仅支持jpg和png格式，大小不超过2M。'
                  : '说明：建议上传750*360像素的图片，仅支持jpg和png格式，大小不超过2M。'
              }
              callbackImgUrl={this.backgroundImgUrl}
            />
          )}
        </Item>
      );
    }
    return null;
  };

  renderBanner = (moduleTypeProps, carouselProps) => {
    const { form, formData } = this.props;
    const { getFieldDecorator } = form;
    const { carouselModule, stencilId } = formData;
    const { carousel = '', newsType, moduleType } = carouselModule;
    if (stencilId === 30) {
      return null;
    }
    return (
      <>
        <FormRadioGroup {...moduleTypeProps} />
        {moduleType === 2 && (
          <Item label="轮播内容" className="content">
            {getFieldDecorator('bannerUpload', {
              rules: [{ required: true, message: '请上传轮播图片' }],
            })(
              <BannerUpload
                fileList={carousel ? carousel.split(',') : []}
                imageNumber={5}
                tips="说明：建议上传700*400像素的图片，仅支持jpg和png格式，大小不超过2M，最多可上传5张。"
                callbackImgUrl={this.callbackImgUrl}
              />
            )}
          </Item>
        )}
        {moduleType === 3 && <FormRadioGroup {...carouselProps} />}
        {moduleType === 3 && newsType === 2 && <SelectArticle />}
      </>
    );
  };

  render() {
    const { spinning, form, formData } = this.props;
    const { getFieldsValue, getFieldDecorator } = form;
    const { templateName, carouselModule, stencilId } = formData;
    const { moduleType, newsType } = carouselModule;
    const customerFormItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 24 },
        md: { span: 5 },
        lg: { span: 5 },
        xl: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 24 },
        md: { span: 28 },
        lg: { span: 17 },
        xl: { span: 16 },
      },
    };
    const titleProps = {
      form,
      value: templateName,
      label: '官网名称',
      keyName: 'templateName',
      maxLength: 8,
      suffix: `${(getFieldsValue().templateName && getFieldsValue().templateName.length) || 0}/8`,
      onChange: this.resetTemplateName,
    };
    const moduleTypeProps = {
      form,
      value: moduleType,
      label: '轮播类型',
      keyName: 'moduleType',
      isRequired: true,
      RadioGroupOptions: [
        { label: '图片', value: 2 },
        { label: '资讯', value: 3 },
      ],
      onChange: this.resetModuleType,
    };
    const carouselProps = {
      form,
      value: newsType,
      label: '轮播内容',
      keyName: 'newsType',
      isRequired: true,
      RadioGroupOptions: [
        { label: '最新的5篇文章', value: 1 },
        { label: '自选文章', value: 2 },
      ],
      onChange: this.resetNewsType,
    };
    return (
      <Spin spinning={spinning}>
        <Container breStates={!0} version={2} defaultPadding footerParams={this.renderFooter()}>
          <div className={styles.root}>
            <section className="left">
              <FormCreate customerFormItemLayout={customerFormItemLayout}>
                <Item label="模板样式" style={{ marginBottom: 15 }}>
                  {getFieldDecorator('bannerUpload', {
                    rules: [{ required: true, message: '请选择模板样式' }],
                  })(<SelectModel />)}
                </Item>
                <FormTitle {...titleProps} />
                {stencilId !== 41 &&
                  stencilId !== 42 &&
                  this.renderBanner(moduleTypeProps, carouselProps)}
                {this.renderModelImage()}
                {
                  <Item
                    label={
                      stencilId === 5 || stencilId === 51 || stencilId === 52 || stencilId === 6
                        ? '图标板块设置'
                        : '板块设置'
                    }
                  >
                    {getFieldDecorator('plateSetting', {
                      rules: [{ required: true }],
                    })(<PlateSetting moduleStyle="other" />)}
                  </Item>
                }
                {stencilId === 6 && (
                  <Item label="图片板块设置">
                    {getFieldDecorator('plateSetting', {
                      rules: [{ required: true }],
                    })(<PlateSetting moduleStyle="image" />)}
                  </Item>
                )}
                {(stencilId === 5 || stencilId === 51 || stencilId === 52 || stencilId === 6) && (
                  <Item label="列表板块设置">
                    {getFieldDecorator('plateSetting', {
                      rules: [{ required: true }],
                    })(<PlateSetting moduleStyle="list" />)}
                  </Item>
                )}
                {(stencilId === 41 || stencilId === 42) &&
                  this.renderBanner(moduleTypeProps, carouselProps)}
              </FormCreate>
            </section>
            <section className="right">
              <PhonePreview />
            </section>
          </div>
        </Container>
      </Spin>
    );
  }
}

export default Homepage;
